<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">        

       <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
		  <el-form-item>
          	  <el-select v-model="query.default_shipping" clearable remote  filterable placeholder="请选择是否默认模板" @change="query.ischange=true">	            
                  <el-option v-for="(item,index) in defaultshippinglists" :label="item.name" :value="item.id" :key="index" />            
              </el-select>          
          </el-form-item>
          <el-form-item>
          	  <el-select v-model="query.temptypelists" clearable remote  filterable placeholder="请选择适用渠道" @change="query.ischange=true">	            
                  <el-option v-for="(item,index) in temptypelists" :label="item.name" :value="item.id" :key="index" />            
              </el-select>          
          </el-form-item>
		  <el-form-item ref="query.key">
			  <el-input placeholder="请输入模板名称" v-model="query.key" clearable @change="query.ischange=true" style="width:100%" @keyup.enter.native="getshippinglists"></el-input>
		  </el-form-item>
		  <el-form-item>
			  <el-button size="small" type="primary" icon="el-icon-search" @click="getshippinglists">搜索</el-button>
			  <el-button size="small" type="danger" icon="el-icon-plus" @click="addtemplateinfos">新增模板</el-button>
		  </el-form-item>
	  </el-form>

      <div class="backborder2" style="margin-top:10px">
      <el-table :data="lists" style="width:100%" v-loading="query.loading">
          <el-table-column label="ID" prop="id" width="100" />
		  <el-table-column label="模板名称">
			  <template slot-scope="props">
				      <div class="shipping-temp-model-name">
                          {{props.row.name}}
                          <el-tooltip placement="top">
				              <div slot="content">新增或编辑线上商城商品 / 一件代发商品时如没有<br/>选择运费模板时，默认使用该模板</div>
                              <i v-if="props.row.default_shipping==1">默认模板</i>
                          </el-tooltip>
                      </div>
              </template>
		  </el-table-column>
          <el-table-column label="模板类型" width="150" align="center">
			  <template slot-scope="props">
				  <div>{{props.row.temptype==1 ? '普通模板' : '一件代发模板'}}</div>
			  </template>
		  </el-table-column>
          <el-table-column label="当前适用商品数" prop="nums" width="150" align="center"/>
          <el-table-column label="添加时间" prop="inputtime" width="170" align="center"/>
          <el-table-column label="操作" width="250" align="center">
			  <template slot-scope="props">
				  <el-button type="warning" size="small" round @click="gettempinfos(props.row)">编辑</el-button>
                  <el-tooltip placement="top">
				      <div slot="content">将未设置有运费模板的线上商城商品 / 一件代发商品绑定当前模板</div>
                      <el-button type="warning" size="small" round @click="settinggoodsinfos(props.row)">批量绑定</el-button>
                  </el-tooltip>
                  <el-button type="" size="small" round @click="deltemps(props.row)">删除</el-button>
			  </template>
		  </el-table-column>
      </el-table>
      <div class="block">
		  <el-pagination 
		      @size-change="orderpageSizeChange" 
		      @current-change="orderpageCurrentChange"
		      :current-page="query.p"
		      :page-sizes="[10, 20, 50]"
		      :page-size="query.rollpage"
		      layout="total, sizes, prev, pager, next, jumper"
		      :total="query.rows">
	      </el-pagination>
	  </div>
      </div>

     
      <!-- 新增快递模板 -->
      <el-dialog title="新增 / 编辑运费模板" :visible.sync="addtempDialog"  width="98%" top="5vh" :before-close="closewindows">
        <div v-loading="savetempsloading">
          <div class="shippingnew-warning-out"> 
              <div class="shippingnew-warning-info">1、当下单金额满足起送金额但不满足包邮金额时启用快递运费计算；</div>
              <div class="shippingnew-warning-info">2、运费计算公式 = 首重金额 + 续重金额 * （实际快递重量 - 首重重量）。</div>
          </div>
          
          <!-- 模板名称 -->
          <div class="shippingnew-temps-model-label-out"><div class="shippingnew-temps-model-labels">基础信息设置</div></div>
          <div class="shippingnew-temps-model shippingnew-width10">
              <div class="shippingnew-temps-model-title">模板名称</div>
              <div class="shippingnew-temps-model-content shippingnew-width08"><el-input v-model="addoreditquery.name" placeholder="请输入模板名称" size="small" /></div>
          </div>
          <!-- 适用渠道 -->
          <div class="shippingnew-temps-model shippingnew-width025">
              <div class="shippingnew-temps-model-title">适用渠道</div>
              <div class="shippingnew-temps-model-content shippingnew-width05">
                  <el-select size="small" v-model="addoreditquery.temptype" remote  filterable placeholder="请选择适用渠道" :disabled="addoreditquery.id > 0 ? true : false">	            
                      <el-option v-for="(item,index) in temptypelists" :label="item.name" :value="item.id" :key="index" />            
                  </el-select>       
              </div>
              <el-tooltip placement="top">
				  <div slot="content">普通商品为适用于线上商城的商品可使用该模板，<br/>一件代发商品为线上商城一件代发专区的商品可使用该模板</div>
                  <div class="shippingnew-temps-model-label"><span>?</span></div>
              </el-tooltip>
          </div>
          <!-- 是否设置成默认模板 -->
          <div class="shippingnew-temps-model shippingnew-width025">
              <div class="shippingnew-temps-model-title">是否默认</div>
              <div class="shippingnew-temps-model-content shippingnew-width05">
                  <el-select size="small" v-model="addoreditquery.default_shipping" remote  filterable placeholder="请选择是否为默认模板">	            
                      <el-option v-for="(item,index) in defaultshippinglists" :label="item.name" :value="item.id" :key="index" />            
                  </el-select>       
              </div>
              <el-tooltip placement="top">
				  <div slot="content">默认模板为当新增或编辑线上商城和一件代发专区商品时，<br/>如商品无指定使用运费模板时绑定该模板</div>
                  <div class="shippingnew-temps-model-label"><span>?</span></div>
              </el-tooltip>
          </div>
          <!-- 选择快递 -->
          <div class="shippingnew-temps-model shippingnew-width025">
              <div class="shippingnew-temps-model-title">选择快递</div>
              <div class="shippingnew-temps-model-content shippingnew-width05">
                  <el-select size="small" v-model="addoreditquery.logisticsid" clearable remote  filterable placeholder="请选择快递">	            
                      <el-option v-for="(item,index) in shippinglists" :label="item.name" :value="item.id" :key="index" />            
                  </el-select>       
              </div>
              <el-tooltip placement="top">
				  <div slot="content">如无快递信息请前往快递管理添加</div>
                  <div class="shippingnew-temps-model-label"><span>?</span></div>
              </el-tooltip>
          </div>  
          
          <div class="shippingnew-temps-model-label-out shippingnew-top03">
              <div class="shippingnew-temps-model-labels">运费设置</div>
              <div class="shippingnew-temps-model-button"><el-button type="warning" size="small" round @click="selectcitys">添加城市</el-button></div>
              <div class="shippingnew-temps-model-button"><el-button type="primary" size="small" round @click="settingalltemps(0)">批量设置全部运费</el-button></div>
          </div>
          
          <!-- 城市信息 -->
          <div class="shippingnew-temps-datalists shippingnew-top02 shippingnew-bottom02" v-for="(t,i) in addoreditquery.datas" :key="i">
              <div class="shippingnew-temps-datalists-infos shippingnew-bottom01">
                  <div class="shippingnew-temps-datalists-infos-title">
                    {{t.name}}
                    <el-tooltip placement="top">
                        <div slot="content">当商品在收货地没有设置相应的运费时，启用该默认值进行运费计算</div>
                        <div class="shippingnew-temps-model-label" v-if="t.provinceid==0"><span>?</span></div>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="展开/收缩城市运费信息" placement="top-start">
                        <el-button type="" size="small" circle icon="el-icon-sort"  @click="showorclosecity(i)" v-if="t.provinceid > 0" style="margin-left:10px"/>
                    </el-tooltip>
                  </div>
                  <div class="shippingnew-temps-datalists-infos-button" v-if="t.provinceid > 0">
                      <el-button type="warning" size="small" round style="display:inline-block" @click="settingalltemps(t.provinceid)">批量设置省份运费</el-button>
                      <el-button type="danger" size="small" round style="display:inline-block" @click="delprovincesprice(i)">删除</el-button>
                  </div>
              </div>
              <div :class="i==0 || t.maxheight > 0 ? 'shippingnew-temps-datalists-settings-out-max' : 'shippingnew-temps-datalists-settings-out'">
              <div class="shippingnew-temps-datalists-settings" v-for="(tt,ii) in t.child" :key="ii">
                  <div class="shippingnew-temps-datalists-settings-citys shippingnew-width007">{{tt.name}}</div>
                  <div class="shippingnew-temps-datalists-settings-types shippingnew-width012">
                      <div class="shippingnew-temps-datalists-settings-types-name shippingnew-width033">起送金额</div>
                      <el-input type="text" v-model="tt.sendprice" size="small" class="shippingnew-width06"/>
                  </div>
                  <div class="shippingnew-temps-datalists-settings-types shippingnew-width02">
                      <div class="shippingnew-temps-datalists-settings-types-name shippingnew-width02">包邮方式</div>
                      <el-select size="small" v-model="tt.noticetype" clearable remote  filterable class="shippingnew-width04">	            
                          <el-option v-for="(item,index) in temptypeinfos" :label="item.name" :value="item.id" :key="index" />            
                      </el-select>   
                      <el-input type="text" size="small" v-model="tt.noticeprice" placeholder="包邮金额" v-if="tt.noticetype==1" class="shippingnew-width033"/> 
                  </div>
                  <div class="shippingnew-temps-datalists-settings-types shippingnew-width012">
                      <div class="shippingnew-temps-datalists-settings-types-name shippingnew-width05" v-if="tt.noticetype!=3">首重重量(kg)</div>
                      <el-input type="text" size="small" v-model="tt.startweight" v-if="tt.noticetype!=3" class="shippingnew-width05" />
                  </div>
                  <div class="shippingnew-temps-datalists-settings-types shippingnew-width012">
                      <div class="shippingnew-temps-datalists-settings-types-name shippingnew-width03" v-if="tt.noticetype!=3">首重金额</div>
                      <el-input type="text" size="small" v-model="tt.startprice"  v-if="tt.noticetype!=3" class="shippingnew-width05"></el-input>
                  </div>
                  <div class="shippingnew-temps-datalists-settings-types shippingnew-width012">
                      <div class="shippingnew-temps-datalists-settings-types-name shippingnew-width05" v-if="tt.noticetype!=3">续重重量(kg)</div>
                      <el-input type="text" size="small" v-model="tt.againweight" placeholder="续重重量" v-if="tt.noticetype!=3" class="shippingnew-width05"></el-input>
                  </div>
                  <div class="shippingnew-temps-datalists-settings-types shippingnew-width012">
                      <div class="shippingnew-temps-datalists-settings-types-name shippingnew-width03" v-if="tt.noticetype!=3">续重金额</div>
                      <el-input type="text" size="small" v-model="tt.againprice" placeholder="续重金额" v-if="tt.noticetype!=3" class="shippingnew-width05"></el-input>
                  </div>
                  <div class="shippingnew-temps-datalists-settings-types shippingnew-width005" style="float:right" v-if="tt.provinceid > 0">
                      <el-button type="danger" size="mini" circle icon="el-icon-delete" @click="delcityprice(i,ii)" />
                  </div>
              </div>
              </div>
          </div>
          <div slot="footer" class="dialog-footer" style="text-align:right">
              <el-button type="primary" size="small" @click="savemytemps">保存</el-button>
              <el-button size="small" @click="addtempDialog = false">取 消</el-button>
          </div>
        </div>
      </el-dialog>


      <!-- 设置品牌可售区域 -->
      <el-dialog title="设置适配运费模板适配城市" :visible.sync="settingDialog" width="45%" top="5vh">
            <div v-loading="cityloading">
                <el-tree 
                    :data="citylists" 
                    ref="citytreeinfos" 
                    highlight-current 
                    show-checkbox node-key="id" 
                    @check="selectcityids"
                >
                </el-tree>
                <div slot="footer" class="dialog-footer" style="margin-top:40px;text-align:right">
                    <el-button type="primary" size="small" @click="addcitytoshipping">确定</el-button>
                    <el-button size="small" @click="settingDialog = false">取 消</el-button>
                </div>
            </div>
      </el-dialog>

      <!-- 批量设置运费信息 -->
      <el-dialog title="批量设置运费信息" :visible.sync="settingmoreDialog" width="25%" top="5vh">
            <div class="shippingnew-selectcity-more" v-if="selectallprovinceid.length > 0">
                <el-checkbox v-model="value.checked" v-for="(value,index) in selectallprovinceid" :key="index">{{value.name}}</el-checkbox>
            </div>

            <el-form :inline="true" class="demo-form-inline" size="small">
                <el-form-item label-width="140" label="起送金额">
                    <el-input type="text" v-model="settingmoreinfos.sendprice" size="small" placeholder="请输入起送金额"><template slot="prepend">￥</template></el-input>
                </el-form-item>
                <el-form-item label-width="140" label="包邮方式">
                    <el-select size="small" v-model="settingmoreinfos.noticetype" clearable remote  filterable placeholder="请选择包邮方式">	            
                        <el-option v-for="(item,index) in temptypeinfos" :label="item.name" :value="item.id" :key="index" />            
                    </el-select>   
                </el-form-item>
                <el-form-item label-width="140" label="包邮金额" v-if="settingmoreinfos.noticetype==1">
                    <el-input type="text" v-model="settingmoreinfos.noticeprice" size="small" placeholder="请输入包邮金额"><template slot="prepend">￥</template></el-input>
                </el-form-item>
                <el-form-item label-width="140" label="首重重量" v-if="settingmoreinfos.noticetype!=3">
                    <el-input type="text" v-model="settingmoreinfos.startweight" size="small" placeholder="请输入首重重量"><template slot="append">kg</template></el-input>
                </el-form-item>
                <el-form-item label-width="140" label="首重金额" v-if="settingmoreinfos.noticetype!=3">
                    <el-input type="text" v-model="settingmoreinfos.startprice" size="small" placeholder="请输入首重金额"><template slot="prepend">￥</template></el-input>
                </el-form-item>
                <el-form-item label-width="140" label="续重重量" v-if="settingmoreinfos.noticetype!=3">
                    <el-input type="text" v-model="settingmoreinfos.againweight" size="small" placeholder="请输入续重重量"><template slot="append">kg</template></el-input>
                </el-form-item>
                <el-form-item label-width="140" label="续重金额" v-if="settingmoreinfos.noticetype!=3">
                    <el-input type="text" v-model="settingmoreinfos.againprice" size="small" placeholder="请输入续重金额"><template slot="prepend">￥</template></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" style="text-align:right">
                <el-button type="primary" size="small" @click="savemoresetting">确定</el-button>
                <el-button size="small" @click="settingmoreDialog = false">取 消</el-button>
            </div>
      </el-dialog>


  </div>
  </transition>   
</template>

<script>

export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Shippingarea/index",
      transitionshow:true,
      query: {
          act:'getshippingtemplistsnew',
          token:this.$cookies.get('token'),
          default_shipping:'',
          temptype:'',
          key:'',
          p:1,
          rollpage:10,
          rows:0,
          loading:false,
          ischange:false,
      },
      lists:[],

      defaultshippinglists:[{id:1,name:'默认模板'},{id:2,name:'非默认模板'}],
      temptypelists:[{id:1,name:'普通商品'},{id:2,name:'一件代发商品'}],
      temptypeinfos:[{id:1,name:'部分包邮'},{id:2,name:'不包邮'},{id:3,name:'包邮'}],
      addtempDialog:false,

      addoreditquery: {
          act:'addtempnews',
          token:this.$cookies.get('token'),
          id:'',
          name:'',
          logisticsid:'',
          logisticsname:'',
          default_shipping:2,
          temptype:1,
          datas:[
              {  
                 name:'默认',
                 'provinceid':0,
                 'maxheight':0,
                 child:[
                    {provinceid:0,cityid:0,name:'默认运费',sendprice:'',noticetype:1,noticeprice:'',startweight:'',startprice:'',againweight:'',againprice:''},
                 ],
              },
          ],
      },

      //运费设置模型，无实际意义，仅供参考
      shippingsettingmodel:[
          {  
            name:'默认',
            'provinceid':0,
            child:[
                {provinceid:0,cityid:0,name:'默认运费',sendprice:10.00,noticetype:1,noticeprice:50.00,startweight:10.00,startprice:20.00,againweight:1,againprice:20.00},
            ],

          },
          {  
            name:'广东省',
            'provinceid':5,
            child:[
                {provinceid:5,cityid:77,name:'汕尾市',sendprice:10.00,noticetype:1,noticeprice:50.00,startweight:10.00,startprice:20.00,againweight:1,againprice:20.00},
                {provinceid:5,cityid:78,name:'广州市',sendprice:10.00,noticetype:1,noticeprice:50.00,startweight:10.00,startprice:20.00,againweight:1,againprice:20.00},
                {provinceid:5,cityid:79,name:'深圳市',sendprice:10.00,noticetype:1,noticeprice:50.00,startweight:10.00,startprice:20.00,againweight:1,againprice:20.00},
            ],

          },
      ],

      shippinglists:[],
      settingDialog:false,
      citylists:[],
      cityloading:false,

      settingmoreDialog:false,
      settingmoreinfos: {
          provinceid:'',
          sendprice:'',
          noticetype:'',
          noticeprice:'',
          startweight:'',
          startprice:'',
          againprice:'',
          againweight:'',
      },
      savetempsloading:false,
      selectallprovinceid:[],

    }  
  },
  mounted(){
      this.getshippinglists(); //获取快递模板信息
      this.getshippings();     //获取快递信息
  },
  methods:{

      /** 展开/搜索城市信息 **/
      showorclosecity(i) {
          var _this=this;
          this.addoreditquery.datas.forEach(function(item,ii) {
              if(i!=ii && ii!=0) {
                  item.maxheight=0;
              }else if(i==ii && item.maxheight==0) {
                  item.maxheight=10000000; 
              }else if(i==ii && item.maxheight > 0) {
                  item.maxheight=0; 
              }
          });
      },



      /** 删除模板信息 **/
      deltemps(item) {
          this.$confirm('删除该模板将导致其绑定的商品运费计算失效，是否继续 ?', '提示', { type: 'warning' }).then(() => {
                var resource = this.$resource(this.url);
                resource.save({act:'deltempnes',token:this.$cookies.get('token'),id:item.id}).then((res) => {
                    if(res.data.Result>0){
                        if(res.data.Result=='70001') this.$router.push('/login')
                        this.$message.error(res.data.Message);
                    }else{
                        this.getshippinglists();
                    }
                }).catch((res) => {
                    
                });

          }).catch(() => {
            
          })
      },


      /** 关闭模板窗口 **/
      closewindows() {
          this.$confirm('您是否要放弃当前已编辑的数据关闭该页面 ?', '提示', { type: 'warning' }).then(() => {
			  this.cleartempinfos();
              this.addtempDialog=false;  

          }).catch(() => {
            
          })
      },

      /** 获取模板详情信息 **/
      gettempinfos(item) {
          this.addtempDialog=true;
          this.savetempsloading=true;

          var resource = this.$resource(this.url);
	      resource.save({act:'tempinfosnew',token:this.$cookies.get('token'),id:item.id}).then((res) => {
		      if(res.data.Result>0){
		          if(res.data.Result=='70001') this.$router.push('/login')
		          this.$message.error(res.data.Message);
				  this.savetempsloading=false;
		      }else{
		          var result = JSON.parse(Base64.decode(res.data.Data));
                  this.addoreditquery.act="edittempnews";
                  this.addoreditquery.id=item.id;
                  this.addoreditquery.name=result.name;
                  this.addoreditquery.logisticsid=result.logisticsid;
                  this.addoreditquery.default_shipping=Number(result.default_shipping);
                  this.addoreditquery.temptype=Number(result.temptype);
                  this.addoreditquery.datas=result.datas;
				  this.savetempsloading=false;                      
		      }
	      }).catch((res) => {
			  this.savetempsloading=false;
	      });

      },


      /** 获取模板信息 **/
      getshippinglists() {
          if(this.query.ischange) {
              this.query.p=1;
              this.query.rollpage=10;
          }

          this.query.loading=true;
          var resource = this.$resource(this.url);
	      resource.save(this.query).then((res) => {
		      if(res.data.Result>0){
		          if(res.data.Result=='70001') this.$router.push('/login')
		          this.$message.error(res.data.Message);
				  this.query.loading=false;
		      }else{
		          this.lists = JSON.parse(Base64.decode(res.data.Data));
		          this.query.rows=parseInt(res.data.count);
		          if(this.query.ischange==true) this.query.ischange=false;	
				  this.query.loading=false;                      
		      }
	      }).catch((res) => {
			  this.query.loading=false;
	      });
      },

      /** 下一页 **/
  	  orderpageSizeChange(val) {
  	      this.query.rollpage = val;
          this.getshippinglists();
  	  },
  	  /** 下一页 **/
  	  orderpageCurrentChange(val) {
  	      this.query.p = val;
          this.getshippinglists();
  	  },

      
       /** 批量匹配 **/
      settinggoodsinfos(item) {
          this.$confirm('您是否将该模板匹配到线上商城 / 一件代发中未匹配有模板的商品中 ?', '提示', { type: 'warning' }).then(() => {
			    var resource = this.$resource(this.url);
                resource.save({act:'settingmoregoodstemps',token:this.$cookies.get('token'),id:item.id}).then((res) => {
                    if(res.data.Result>0){
                        if(res.data.Result=='70001') this.$router.push('/login')
                        this.$message.error(res.data.Message);
                    }else{
                        this.getshippinglists();              
                    }
                }).catch((res) => {
                    
                });

          }).catch(() => {
            
          })
      },


      /** 保存运费模板信息 **/
      savemytemps() {
          this.$confirm('是否保存该模板信息 ?', '提示', { type: 'warning' }).then(() => {
			 this.savemytempdatas(1);   
          }).catch(() => {
             
          });

      },

      savemytempdatas(savetype) {
          var data={};
          data.act=this.addoreditquery.act;
          data.token=this.addoreditquery.token;
          data.id=this.addoreditquery.id;
          data.name=this.addoreditquery.name;
          data.logisticsid=this.addoreditquery.logisticsid;
          data.logisticsname=this.addoreditquery.logisticsname;
          data.default_shipping=this.addoreditquery.default_shipping;
          data.temptype=this.addoreditquery.temptype;
          data.savetype=savetype;
          data.datas=JSON.stringify(this.addoreditquery.datas);

          this.savetempsloading=true;
          var resource = this.$resource(this.url);
          resource.save(data).then((res) => {
			  if(res.data.Result>0){
				  if(res.data.Result=='70001') this.$router.push('/login')
				  this.$message.error(res.data.Message);
				  this.savetempsloading=false;
			  }else{		  
				  this.savetempsloading=false;
                  this.addtempDialog=false;
                  this.cleartempinfos();
                  this.getshippinglists();
			  }
		  }).catch((res) => {
			  this.savetempsloading=false;
		  });
      },


      /** 批量设置运费信息 **/
      savemoresetting() {
          var _this=this;
          var numReg = /^[0-9]+([.]{1}[0-9]+){0,1}$/;
          var numRe = new RegExp(numReg);
          if(this.settingmoreinfos.sendprice=='' || !numRe.test(this.settingmoreinfos.sendprice)) {this.$message.error('请设置正确的起送金额');return false;}
          if(this.settingmoreinfos.noticetype=='')  {this.$message.error('请选择包邮方式');return false;}
          if(this.settingmoreinfos.noticetype==1 && this.settingmoreinfos.noticeprice=='') {this.$message.error('请设置正确的包邮金额');return false;}
          if(this.settingmoreinfos.noticetype==1 && !numRe.test(this.settingmoreinfos.noticeprice)) {this.$message.error('请设置正确的包邮金额');return false;}
          if(this.settingmoreinfos.noticetype!=3 && (this.settingmoreinfos.startweight=='' || !numRe.test(this.settingmoreinfos.startweight))) {
              this.$message.error('请设置正确的首重重量');
              return false;
          }
          if(this.settingmoreinfos.noticetype!=3 && (this.settingmoreinfos.startprice=='' || !numRe.test(this.settingmoreinfos.startprice))) {
              this.$message.error('请设置正确的首重金额');
              return false;
          }
          if(this.settingmoreinfos.noticetype!=3 && (this.settingmoreinfos.againweight=='' || !numRe.test(this.settingmoreinfos.againweight))) {
              this.$message.error('请设置正确的续重重量');
              return false;
          }
          if(this.settingmoreinfos.noticetype!=3 && (this.settingmoreinfos.againprice=='' || !numRe.test(this.settingmoreinfos.againprice))) {
              this.$message.error('请设置正确的续重金额');
              return false;
          }
          if(this.settingmoreinfos.noticetype==2 || this.settingmoreinfos.noticetype==3) {
              this.settingmoreinfos.noticeprice='';
          }

          if(this.settingmoreinfos.noticetype==3) {
              this.settingmoreinfos.startweight='';
              this.settingmoreinfos.startprice='';
              this.settingmoreinfos.againweight='';
              this.settingmoreinfos.againprice='';
          }

          
          if(this.selectallprovinceid.length==0) {this.$message.error("您还没有添加相应的省份信息，请先添加省份信息");return false;}
          var provinceids=[];
          this.selectallprovinceid.forEach(function(item,i) {
              if(item.checked==true) provinceids.push(item.id);
          });

          if(provinceids.length==0) {this.$message.error("请选择您要批量设置的省份");return false;}
          var msg="该操作将会覆盖下面选中城市的运费信息，是否继续 ？";
          var number=-1;

          this.$confirm(msg, '提示', { type: 'warning' }).then(() => {
			    this.addoreditquery.datas.forEach(function(t,i) {
                    number=provinceids.indexOf(t.provinceid);
                    if(number >=0 ) {
                        t.child.forEach(function(tt,ii) {
                            tt.sendprice=_this.settingmoreinfos.sendprice;
                            tt.noticetype=_this.settingmoreinfos.noticetype;
                            tt.noticeprice=_this.settingmoreinfos.noticeprice;
                            tt.startweight=_this.settingmoreinfos.startweight;
                            tt.startprice=_this.settingmoreinfos.startprice;
                            tt.againweight=_this.settingmoreinfos.againweight;
                            tt.againprice=_this.settingmoreinfos.againprice;
                        });
                    }
                });
                this.settingmoreDialog=false;

          }).catch(() => {
            
          });



          /**
          var provinceid=this.settingmoreinfos.provinceid;
          var msg='';
          provinceid==0 ? 
          msg="该操作将会覆盖下面所有城市的运费信息，是否继续 ？" : 
          msg="该操作将会覆盖当前省份下所有城市的运费信息，是否继续 ？";

          this.$confirm(msg, '提示', { type: 'warning' }).then(() => {
			    if(provinceid==0) { //设置全部
                    this.addoreditquery.datas.forEach(function(t,i) {
                        t.child.forEach(function(tt,ii) {
                            tt.sendprice=_this.settingmoreinfos.sendprice;
                            tt.noticetype=_this.settingmoreinfos.noticetype;
                            tt.noticeprice=_this.settingmoreinfos.noticeprice;
                            tt.startweight=_this.settingmoreinfos.startweight;
                            tt.startprice=_this.settingmoreinfos.startprice;
                            tt.againweight=_this.settingmoreinfos.againweight;
                            tt.againprice=_this.settingmoreinfos.againprice;
                        });
                    });

                }else { //设置指定省份
                    this.addoreditquery.datas.forEach(function(t,i) {
                        t.child.forEach(function(tt,ii) {
                            if(tt.provinceid==provinceid) {
                                tt.sendprice=_this.settingmoreinfos.sendprice;
                                tt.noticetype=_this.settingmoreinfos.noticetype;
                                tt.noticeprice=_this.settingmoreinfos.noticeprice;
                                tt.startweight=_this.settingmoreinfos.startweight;
                                tt.startprice=_this.settingmoreinfos.startprice;
                                tt.againweight=_this.settingmoreinfos.againweight;
                                tt.againprice=_this.settingmoreinfos.againprice;
                            }
                        });
                    });

                }
                this.settingmoreDialog=false;

          }).catch(() => {
            
          });
          */

      },


      /** 批量设置运费 **/
      settingalltemps(provinceid) {
          this.settingmoreDialog=true;
          this.settingmoreinfos.provinceid=provinceid;
          this.settingmoreinfos.sendprice='';
          this.settingmoreinfos.noticetype='';
          this.settingmoreinfos.noticeprice='';
          this.settingmoreinfos.startweight='';
          this.settingmoreinfos.startprice='';
          this.settingmoreinfos.againprice='';
          this.settingmoreinfos.againweight='';

          //获取所有已添加的省份信息
          this.selectallprovinceid=[];
          var _this=this;
          var ischeck=false;
          this.addoreditquery.datas.forEach(function(item,i) {
              ischeck=false;
              if(provinceid==0) ischeck=true;
              if(provinceid > 0 && item.provinceid==provinceid) ischeck=true;
              if(i > 0) _this.selectallprovinceid.push({id:item.provinceid,name:item.name,checked:ischeck});
          });
      },

      /** 删除省份下所有城市的运费 **/
      delprovincesprice(index) {
          this.$confirm('您是否要删除当前省份下所有城市的运费设置 ?', '提示', { type: 'warning' }).then(() => {
			    this.$delete(this.addoreditquery.datas,index);

          }).catch(() => {
            
          });
      },

      /** 删除当前城市的运费 **/
      delcityprice(i,ii) {
          this.$confirm('您是否要删除当前城市的运费设置 ?', '提示', { type: 'warning' }).then(() => {
			    this.$delete(this.addoreditquery.datas[i].child,ii);
                if(this.addoreditquery.datas[i].child.length==0) this.$delete(this.addoreditquery.datas,i);

          }).catch(() => {
            
          });
      },


      /** 新增城市信息到快递模板 **/
      addcitytoshipping() {
          this.cityloading=true;
          var ids=this.$refs.citytreeinfos.getCheckedKeys();
          var data=[];
          var item='';
          var _this=this;
          var param={};

          //便利取出数据
          this.citylists[0].children.forEach(function(e,i) {
              if(e.children.length > 0) {
                  e.children.forEach(function(ee,ii) {
                      if(ids.indexOf(ee.id) >= 0) data.push(ee);
                  });
              }
          });
          
          //组装商品信息
          data.forEach(function(t,i) {
              item='';
              //检查原已添加的商品里是否有该商品信息
              _this.addoreditquery.datas.forEach(function(tt,ii) {
                  if(ii > 0) tt.maxheight=0;
                  if(t.parentid==tt.provinceid) item=tt;
              });

              if(item=='') { //还没有添加过该省份的信息
                  param={name:t.parentname,maxheight:0,provinceid:t.parentid,child:[]};
                  param.child.push({provinceid:t.parentid,cityid:t.id,name:t.label,sendprice:'',noticetype:1,noticeprice:'',startweight:'',startprice:'',againweight:'',againprice:''});
                  _this.addoreditquery.datas.push(param);

              }else { //已经添加过该省份的信息
                  item.child.push({provinceid:t.parentid,cityid:t.id,name:t.label,sendprice:'',noticetype:1,noticeprice:'',startweight:'',startprice:'',againweight:'',againprice:''});

              }

          });

          this.cityloading=false;
          this.settingDialog=false;
          
      },


      /** 选择城市模板 **/
      selectcitys() {
          this.settingDialog=true;
		  this.citylists=[];
		  this.cityloading=true;
		  var resource = this.$resource(this.url);

          var ids=[];
          for(var i=0;i < this.addoreditquery.datas.length; i++) {
              this.addoreditquery.datas[i].child.forEach(function(item,index) {
                  if(item.cityid > 0) ids.push(item.cityid);
              });
          }


		  resource.save({act:'getcitylistsinfos',cityids:ids.join(','),token:this.$cookies.get('token')}).then((res) => {
			  if(res.data.Result>0){
				  if(res.data.Result=='70001') this.$router.push('/login')
				  this.$message.error(res.data.Message);
				  this.cityloading=false;
			  }else{
				  var result=JSON.parse(Base64.decode(res.data.Data));
				  this.citylists=result.data;				  
				  //this.$refs.citytreeinfos.setCheckedKeys(this.addtemplate.cityids);
				  this.cityloading=false;
			  }
		  }).catch((res) => {
			  this.cityloading=false;
		  });
      },


      //新增模板信息
      addtemplateinfos() {
          this.addoreditquery.id='';
          this.addoreditquery.act='addtempnews';
          this.addoreditquery.name='';
          this.addoreditquery.logisticsid='';
          this.addoreditquery.logisticsname='';
          this.addoreditquery.default_shipping=2;
          this.addoreditquery.temptype=1;
          this.addoreditquery.datas=[];
          this.addoreditquery.datas.push(
              {name:'默认',
               provinceid:0,
               maxheight:500,
               child:[
                  {provinceid:0,cityid:0,name:'默认运费',sendprice:'',noticetype:1,noticeprice:'',startweight:'',startprice:'',againweight:'',againprice:''},
               ]
              },
          );
          this.addtempDialog=true;
      },

    
      //清除选中数据
      cleartempinfos() {
          this.addoreditquery.id='';
          this.addoreditquery.name='';
          this.addoreditquery.logisticsid='';
          this.addoreditquery.logisticsname='';
          this.addoreditquery.default_shipping=2;
          this.addoreditquery.temptype=1;
          this.addoreditquery.datas=[];
      },


      /** 获取本地快递信息 **/
	  getshippings() {
		  var resource = this.$resource(this.GLOBAL.domain+"Express/index");
		  resource.save({act:'lists',p:1,rollpage:100000,token:this.$cookies.get('token')}).then((res) => {
			  if(res.data.Result>0){
				  if(res.data.Result=='70001') this.$router.push('/login')
				  this.$message.error(res.data.Message);
			  }else{
				  this.shippinglists=JSON.parse(Base64.decode(res.data.Data));
			  }
		  }).catch((res) => {
			  
		  });
	  },
    
  }

}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.shippingnew-warning-out {display:inline-block;width:calc(100% - 20px - 2px);padding:5px 10px;background:rgba(221,221,221,.5);border:1px solid rgba(221,221,221,.8);border-radius:6px;margin:10px 0;}
.shippingnew-warning-info {float:left;color:rgb(245, 108, 108);font-size:13px;line-height:23px;width:100%;font-weight:500}
.shippingnew-temps-model {display:inline-block;font-size:0;margin:10px 0;}
.shippingnew-temps-model-title {display:inline-block;padding:0 5px;font-size:14px;}
.shippingnew-temps-model-content {display:inline-block;padding:0 5px;}
.shippingnew-temps-model-label-out {display:inline-block;width:100%}
.shippingnew-temps-model-label {display:inline-block;padding:0 5px;}
.shippingnew-temps-model-label span {display:flex;justify-content:center;align-items:center;width:15px;height:15px;border-radius:50%;background:#e6a23c;color:#fff;font-size:12px;}
.shippingnew-temps-model-labels {font-size:20px;font-weight:bold;padding:10px;color:#333333;display:inline-block;}
.shippingnew-temps-model-button {display:inline-block;padding:10px 5px;}
.shippingnew-temps-datalists {display:inline-block;width:100%}
.shippingnew-temps-datalists-infos {display:inline-block;width:calc(100% - 20px);border-bottom:1px solid #dddddd;padding:0 10px;}
.shippingnew-temps-datalists-infos-title {font-size:15px;padding:10px 0;display:inline-block;width:40%;font-weight:600;color:#000;}
.shippingnew-temps-datalists-infos-button {display:inline-block;width:calc(60% - 4px);text-align:right}
.shippingnew-temps-datalists-settings {display:inline-block;width:calc(100% - 20px);padding:5px 10px;font-size:0;}
.shippingnew-temps-datalists-settings-citys {float:left;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;font-size:13px;line-height:35px;padding:0 10px;color:#000;font-weight:600}
.shippingnew-temps-datalists-settings-types {float:left;padding:0 5px;min-height:35px}
.shippingnew-temps-datalists-settings-types-name {display:inline-block;font-size:12px;color:#999999;}
.shipping-temp-model-name i {font-style:normal;font-size:12px;line-height:12px;border-radius:15px;padding:2px 10px;color:#fff;background:#66b1ff;margin-left:1%}
.shippingnew-temps-datalists-settings-out {display:inline-block;width:100%;transition:.5s all;overflow:hidden;max-height:0;}
.shippingnew-temps-datalists-settings-out-max {display:inline-block;width:100%;transition:.5s all;overflow:hidden;max-height:1000000px;}
.shippingnew-selectcity-more {padding:10px 0 30px 0;}

.shippingnew-width005 {width:5% !important}
.shippingnew-width007 {width:7% !important}
.shippingnew-width01 {width:10% !important}
.shippingnew-width011 {width:11% !important}
.shippingnew-width012 {width:12% !important}
.shippingnew-width015 {width:15% !important}
.shippingnew-width018 {width:18% !important}
.shippingnew-width02 {width:20% !important}
.shippingnew-width10 {width:100% !important}
.shippingnew-width025 {width:25% !important}
.shippingnew-width03 {width:30% !important}
.shippingnew-width033 {width:33% !important}
.shippingnew-width035 {width:35% !important}
.shippingnew-width04 {width:40% !important}
.shippingnew-width05 {width:50% !important}
.shippingnew-width06 {width:60% !important}
.shippingnew-width08 {width:80% !important}
.shippingnew-top02 {margin-top:20px !important;}
.shippingnew-top03 {margin-top:30px !important;}
.shippingnew-bottom01 {margin-bottom:10px !important;}
.shippingnew-bottom02 {margin-bottom:20px !important;}
</style>


// WEBPACK FOOTER //
// src/components/mall/shippingtemp/Shippingtempnews1.vue